function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.16602 3.23333V0.666664C3.99935 1.08333 0.666016 4.675 0.666016 9C0.666016 13.325 3.99935 16.9167 8.16602 17.3333V14.7667C5.66602 14.3667 3.16602 11.9333 3.16602 9C3.16602 6.06666 5.66602 3.63333 8.16602 3.23333ZM14.8077 8.16666H17.3327C16.941 4 13.9993 1.05833 9.83268 0.666664V3.23333C12.3327 3.59166 14.4493 5.66666 14.8077 8.16666ZM9.83268 14.7667V17.3333C13.9993 16.9417 16.941 14 17.3327 9.83333H14.8077C14.4493 12.3333 12.3327 14.4083 9.83268 14.7667Z",
  fill: "black",
  fillOpacity: 0.54
});

function SvgDougnutWidgetType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDougnutWidgetType);
export default __webpack_public_path__ + "static/media/dougnut_widget_type.c3cb7301.svg";
export { ForwardRef as ReactComponent };